import React, { useState } from 'react'
import { format } from 'date-fns'

const PlanningUsers = ({ _display60Days, _displayHours, _displayStaff, _converteTimeToHours, _choiceHours, valuesService, _updateHours, booking, staff, datesOff, services }) => {
    const [showDay, setShowDay] = useState(0) 
    let m = 1
    let n = 1
    
    return (
        <div className='mt-3'>   
            {/* SI SELECTION */}
            {valuesService.hours ? 
                <>
                    {/* TITRE */}
                    <div className='h5 mt-2'>Date & heure séléctionnées</div>
                    <div className='row pt-3 pb-3 mt-3 shadow'>
                        <div className='col text-start'>{valuesService.dateShow} à {_converteTimeToHours(valuesService.hours)}</div>
                        <div className='col text-end'>
                            <div 
                                className={valuesService.hours ? 'col text-end' : 'col-3 text-end'} 
                                onClick={_updateHours}
                                style={{cursor:'pointer'}}
                            >
                                <u>modifier</u> 
                            </div>
                        </div> 
                    </div>
                </>
            :
                <>
                    {/* TITRE */}
                    <div className='h5 mt-2'>Choix de la date & heure</div>

                    {_display60Days().map((d,i) => (
                        // MAP ARRAY DAYS
                        _displayStaff(d.day,d.date,services,staff,datesOff).length > 0 && m < 8 && m++ &&
                        // AFFICHAGE DES JOURS
                        <div  
                            className='row pt-3 pb-3 mt-3 shadow' 
                            key={i} onClick={() => setShowDay(showDay === i ? '' : i)}
                        >
                            <div className='col text-start'>
                                {d.dateShow} 
                            </div>
                            <div className='col text-end'>
                                <i className=
                                    {showDay === i ? 
                                        "bi bi-chevron-compact-up ms-3" 
                                    : 
                                        "bi bi-chevron-compact-down ms-3"
                                    }></i>
                            </div>

                            {showDay === i &&
                                // AFFICHAGE DES HORAIRES
                                <div className='mt-3 pt-3 d-flex flex-row flex-wrap justify-content-center border-top'>   
                                    {d.surnameStaff} 
                                    {_displayHours().map(h => (
                                        _displayStaff(d.day,d.date,services,staff,datesOff)
                                            .filter(a => (a.amStart <= h && h < a.amEnd) || (a.pmStart <= h && h < a.pmEnd))
                                            .sort(() => Math.random() - 0.5)
                                            .map((a,i) => (
                                                // AFFICHER UNE SEULE REPONSE (TIRER AU SORT UN STAFF)
                                                i === 0 &&
                                                // FILTRER SI CURRENT DAY ET HORAIRES ACTUELS
                                                format(new Date(Date.now()), 'MM/dd/yyyy') === d.date && (new Date(Date.now()).getHours() * 60) / 15 >= h ? null :
                                                // FILTRER SI IL Y A DEJA UNE RESERVATION A CE JOUR
                                                booking.filter(b => b.date === d.date && b.hours === h && b.idStaff === a.idStaff).length === 0 && n++ &&
                                                n === 1 ? "Plus de réservation disponible" :
                                                <div 
                                                    className='d-inline-flex border m-2 p-2 rounded-pill' 
                                                    key={h} 
                                                    style={{ cursor:'pointer' }}
                                                    onClick={() => _choiceHours(
                                                        d.date,
                                                        d.dateShow,
                                                        h,
                                                        a.idStaff,
                                                        a.surnameStaff,
                                                        a.nameStaff,
                                                        a.idService,
                                                        a.nameService,
                                                        a.durationService,
                                                        a.priceService 
                                                    )}
                                                >{_converteTimeToHours(h)}</div> 
                                        ))
                                    ))}
                                </div>
                            }
                        </div>
                    ))}
                </>
            }
        </div>
    )
}

export default PlanningUsers


